"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressOption = void 0;
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _Localization = require("../Localization");
var _defaultTranslations = require("../constants/defaultTranslations");
var _TranslationKey = require("../models/TranslationKey");
var _jsxRuntime = require("react/jsx-runtime");
const StyledBox = (0, _mui.styled)(_mui.MenuItem)(({
  theme
}) => ({
  width: '100%',
  paddingBlock: theme.spacing(1),
  fontWeight: 'normal',
  whiteSpace: 'unset',
  wordBreak: 'break-word',
  '&:hover': {
    cursor: 'pointer',
    backgroundColor: theme.palette.action.hover,
    opacity: 1
  }
}));
const ListStyled = (0, _mui.styled)('div')(() => ({
  whiteSpace: 'normal'
}));
const AddressOption = props => {
  const {
    suggestion,
    onSelect
  } = props;
  const addressSummary = `${suggestion.addressSummary} `;
  const onClick = (0, _react.useCallback)(() => {
    onSelect(suggestion);
  }, [onSelect, suggestion]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledBox, {
    onClick: onClick,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(ListStyled, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        style: {
          fontWeight: 'bold'
        },
        children: suggestion.description
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), addressSummary, suggestion.count !== 1 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _defaultTranslations.defaultTranslations.addressResults,
        id: _TranslationKey.TranslationKey.addressResults,
        values: {
          count: suggestion.count
        }
      })]
    })
  }, suggestion.pathKey ?? suggestion.addressNodeId);
};
exports.AddressOption = AddressOption;
//# sourceMappingURL=AddressOption.js.map